import type { ComponentProps } from 'react'
import { Toaster as Sonner } from 'sonner'

export function Toaster(props: ComponentProps<typeof Sonner>) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-center"
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:border group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:max-w-3xl group-[.toaster]:w-full',
          content: 'font-semibold',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'font-semibold group-[.toast]:bg-primaryBtn break-all',

          info: 'group-[.toaster]:bg-sky-50 group-[.toaster]:border-sky-300 group-[.toaster]:text-sky-500 group-[.toast]:text-sky-500',
          error: 'group-[.toaster]:bg-red-50 group-[.toaster]:border-red-300 group-[.toaster]:text-red-500 group-[.toast]:text-red-500',
          warning: 'group-[.toaster]:bg-amber-50 group-[.toaster]:border-amber-300 group-[.toaster]:text-amber-500 group-[.toast]:text-amber-500',
          success: 'group-[.toaster]:bg-[#F1FCF3] group-[.toaster]:border-[#8FE3A0] group-[.toaster]:text-[#1F5C2C] group-[.toast]:text-[#1F5C2C]',
        },
      }}
      {...props}
    />
  )
}
